import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { GET_DMX_PROFILE_BY_ID } from './actionTypes';
import { getDmxProfileByIdSuccess, getDmxProfileByIdError } from './actions';

import { getDmxAPI } from '../../../api/dmx';

const dmxAPI = getDmxAPI();

function* getProfileById({ payload: { user, profileId } }) {
  try {
    const response = yield call(dmxAPI.getProfileById, user.token, profileId);
    yield put(getDmxProfileByIdSuccess(response));
  } catch (error) {
    yield put(getDmxProfileByIdError(error));
  }
}

export function* watchGetDmxProfileById() {
  yield takeEvery(GET_DMX_PROFILE_BY_ID, getProfileById);
}

function* getDmxProfileByIdSaga() {
  yield all([fork(watchGetDmxProfileById)]);
}

export default getDmxProfileByIdSaga;
